export default __webpack_public_path__ + "static/media/Design team-cuate 1.547a085f.png";